module.exports = __webpack_public_path__ + "img/2.83e67288.png";